import React from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '@cotera/client/v0/lib/utils';
import type { WebhookProviderCatalogEntry } from '../types';
import { WebhookProviderIcon } from '../webhook-provider-icons';

export const WebhookProviderPicker: React.FC<{
  providers: readonly WebhookProviderCatalogEntry[];
  selectedKey: string | null;
  onSelect: (providerKey: WebhookProviderCatalogEntry['key']) => void;
}> = ({ providers, selectedKey, onSelect }) => {
  return (
    <div className="flex flex-col gap-2">
      {providers.map((provider) => {
        const isSelected = provider.key === selectedKey;
        return (
          <button
            key={provider.key}
            type="button"
            onClick={() => onSelect(provider.key)}
            className={cn(
              'group flex items-center gap-3 rounded-lg border p-3 text-left transition-all hover:shadow-sm',
              isSelected
                ? 'border-primary bg-primary/5'
                : 'border-border/60 bg-card hover:border-primary/30 hover:bg-accent/30'
            )}
          >
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md border bg-muted/40">
              <WebhookProviderIcon
                providerKey={provider.key}
                className="h-5 w-5"
              />
            </span>
            <span className="flex min-w-0 flex-1 flex-col justify-center gap-0.5">
              <span className="flex items-center gap-2">
                <span className="truncate text-sm font-medium transition-colors group-hover:text-primary">
                  {provider.displayName}
                </span>
                {provider.status === 'beta' ? (
                  <span className="shrink-0 rounded-full bg-muted px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide text-muted-foreground">
                    Beta
                  </span>
                ) : null}
              </span>
              <span className="line-clamp-2 text-xs text-muted-foreground">
                {provider.description}
              </span>
            </span>
            <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground/40 transition-all group-hover:translate-x-0.5 group-hover:text-muted-foreground" />
          </button>
        );
      })}
    </div>
  );
};
